import { useTranslation } from 'react-i18next';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import clsx from 'clsx';
import { useContext } from '@/components/slider-type/context';
import { useAppDispatch, useAppSelector } from '@/redux/store';
import { ConfigSlice } from '@/redux/config';
import { goToNextStep } from '@/redux/slider/slider.thunks';
import '@/components/slider-type/components/navigation/navigation-v1.css';
import '@/components/slider-type/components/navigation/navigation-v2.css';

export default function Navigation() {
  const { index, slide, onPrevious, onNext } = useContext();
  const cssVersion = useAppSelector(ConfigSlice.selectors.cssVersion);
  const switchSlidesMode = useAppSelector(ConfigSlice.selectors.switchSlidesMode);
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const showPrevious = !(slide.disableButtons || []).includes('prev') && index >= 1;
  const showNext =
    !(slide.disableButtons || []).includes('next') &&
    (!((slide.type === 'multiple-text' || slide.type === 'multiple') && switchSlidesMode === 'on-card') ||
      (slide.choices || []).some((choice) => !!choice.isPreselected) ||
      !!slide.multiple);

  return (
    <div data-css-version={cssVersion} className='slider-type-navigation'>
      <button
        data-testid='navigation-button-previous'
        aria-label={t('Zurück')}
        type='button'
        className={clsx(
          'slider-type-navigation__element',
          'slider-type-navigation__element--prev',
          showPrevious ? 'slider-type-navigation__element--visible' : 'slider-type-navigation__element--hidden',
        )}
        onClick={() => onPrevious()}
      >
        <span>{t('Zurück')}</span>
        <ChevronLeft size={20} strokeWidth={3} className='slider-type-navigation__arrow' />
      </button>
      <button
        data-testid='navigation-button-next'
        aria-label={t('Weiter')}
        type='button'
        className={clsx(
          'slider-type-navigation__element',
          'slider-type-navigation__element--next',
          showNext ? 'slider-type-navigation__element--visible' : 'slider-type-navigation__element--hidden',
        )}
        onClick={() => dispatch(goToNextStep({ key: slide.key, onNext }))}
      >
        <span>{t('Weiter')}</span>
        <ChevronRight size={20} strokeWidth={3} className='slider-type-navigation__arrow' />
      </button>
    </div>
  );
}
